
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postAirUpdateBalance = (params) => {
    return axios.post(`${backendHost}/api/admin/user/balance/air`, params);
};

export {
    postAirUpdateBalance
}